module.exports = __webpack_public_path__ + "static/01-d80ae65764dd74dc73d2801199a7066e.png";